import type { ZudokuConfig } from "zudoku";
import {
  DocsBreadcrumb,
  DocsSidebarHeading,
  DocsArticleSupport,
} from "./src/DocsChrome.js";
import { DocsOverview } from "./src/DocsOverview.js";
import { Portal } from "./src/Portal.js";
import { ProductNavigation } from "./src/ProductNavigation.js";

const config: ZudokuConfig = {
  site: {
    title: "安象产品中心",
    showPoweredBy: false,
    logo: {
      src: { light: "/brand/logo.png", dark: "/brand/logo.png" },
      alt: "安象科技",
      width: 100,
    },
    logoUrl: "/",
  },
  metadata: { title: "安象产品中心", defaultTitle: "安象产品中心" },
  theme: {
    fonts: {
      sans: {
        url: "/fonts/fonts.css",
        fontFamily:
          '"PingFang SC", "Microsoft YaHei", "Anxiang Sans", sans-serif',
      },
      serif: {
        url: "/fonts/fonts.css",
        fontFamily: '"PingFang SC", "Anxiang Sans", sans-serif',
      },
      mono: {
        url: "/fonts/fonts.css",
        fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
      },
    },
    customCss: `:root, .dark { color-scheme: light; --background: #fff; --foreground: #20252c; --card: #fff; --card-foreground: #20252c; --popover: #fff; --popover-foreground: #20252c; --primary: #1677ff; --primary-foreground: #fff; --secondary: #f5f7fa; --secondary-foreground: #20252c; --muted: #f5f7fa; --muted-foreground: #677181; --accent: #edf4ff; --accent-foreground: #1677ff; --border: #e6eaf0; --input: #dce1e8; --sidebar: #fff; --sidebar-foreground: #20252c; --sidebar-accent: #edf4ff; --sidebar-accent-foreground: #1677ff; --font-sans: "PingFang SC", "Microsoft YaHei", "Anxiang Sans", sans-serif; } body { font-family: var(--font-sans); -webkit-font-smoothing: antialiased; } h1, h2, h3, h4, button, input { font-family: inherit; }`,
  },
  slots: {
    "top-navigation-before": <ProductNavigation />,
    "content-before": <DocsBreadcrumb />,
    "navigation-before": <DocsSidebarHeading />,
    "content-after": <DocsArticleSupport />,
  },
  header: {
    themeSwitcher: { enabled: false },
    navigation: [
      { label: "产品中心", to: "/" },
      { label: "文档中心", to: "/overview" },
      { label: "服务支持", to: "/support" },
    ],
  },
  navigation: [
    {
      type: "custom-page",
      path: "/",
      display: "hide",
      element: <Portal />,
      layout: "none",
    },
    {
      type: "category",
      label: "产品总览",
      items: [
        {
          type: "custom-page",
          path: "/overview",
          label: "文档中心",
          element: <DocsOverview />,
          layout: "none",
        },
      ],
    },
    {
      type: "category",
      label: "陪玩交友系统",
      items: [
        "game-companion/demo",
        "game-companion/features",
        "game-companion/feature-list",
        "game-companion/architecture",
        "game-companion/introduction",
        "game-companion/orders",
        "game-companion/operations",
      ],
    },
    {
      type: "category",
      label: "语音直播交友",
      items: ["voice/demo", "voice/features", "voice/architecture"],
    },
    {
      type: "category",
      label: "多人直播交友系统",
      items: ["live/demo", "live/features", "live/architecture"],
    },
    {
      type: "category",
      label: "1对1直播系统",
      items: [
        "one-to-one/demo",
        "one-to-one/features",
        "one-to-one/architecture",
      ],
    },
    {
      type: "category",
      label: "海外直播1对1交友系统",
      items: ["overseas/demo", "overseas/features", "overseas/architecture"],
    },
    {
      type: "category",
      label: "社交娱乐公共资料",
      items: ["products/live-social", "products/operations"],
    },
    {
      type: "category",
      label: "租赁系统",
      items: ["rental/demo", "rental/features", "rental/architecture"],
    },
    {
      type: "category",
      label: "商城系统",
      items: ["commerce/demo", "commerce/features", "commerce/architecture"],
    },
    {
      type: "category",
      label: "量化交易系统",
      items: ["quant/demo", "quant/features", "quant/architecture"],
    },
    {
      type: "category",
      label: "上门预约",
      items: ["booking/demo", "booking/features", "booking/architecture"],
    },
    { type: "category", label: "服务支持", items: ["support"] },
  ],
  docs: {
    files: "/pages/**/*.mdx",
    defaultOptions: { copyPage: false, showLastModified: false },
  },
};

export default config;
